export const CONTRACT_TYPE_LEASING = 2
